import { useRef, useState } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange, testId = "signature-pad" }) {
  const ref = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [hasInk, setHasInk] = useState(false);

  const pos = (e) => {
    const rect = ref.current.getBoundingClientRect();
    const sx = ref.current.width / rect.width;
    const sy = ref.current.height / rect.height;
    return { x: (e.clientX - rect.left) * sx, y: (e.clientY - rect.top) * sy };
  };
  const start = (e) => {
    const ctx = ref.current.getContext("2d");
    ctx.strokeStyle = "#0F172A";
    ctx.lineWidth = 2.4;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    setDrawing(true);
    setHasInk(true);
    ref.current.setPointerCapture?.(e.pointerId);
  };
  const move = (e) => {
    if (!drawing) return;
    const ctx = ref.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
  };
  const end = () => {
    if (!drawing) return;
    setDrawing(false);
    onChange?.(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const ctx = ref.current.getContext("2d");
    ctx.clearRect(0, 0, ref.current.width, ref.current.height);
    setHasInk(false);
    onChange?.(null);
  };

  return (
    <div className="space-y-1.5">
      <canvas ref={ref} width={680} height={280}
        className="w-full h-36 border-2 border-dashed border-slate-300 rounded-xl bg-white touch-none cursor-crosshair"
        data-testid={testId}
        onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} />
      <div className="flex justify-between items-center">
        <p className="text-[10px] text-slate-400">وقّع بالإصبع أو الماوس داخل الإطار</p>
        <button type="button" onClick={clear} data-testid={`${testId}-clear`}
          className="text-[11px] font-semibold text-slate-500 hover:text-rose-600 flex items-center gap-1">
          <Eraser className="w-3.5 h-3.5" /> مسح التوقيع
        </button>
      </div>
      {!hasInk && <span className="sr-only" data-testid={`${testId}-empty`} />}
    </div>
  );
}
